module.exports = __webpack_public_path__ + "img/pp5.f6b45739.png";